import React from 'react'

export default {
  home: 'Hello',
  switchLang: '中文',
  header: {
    button: '立即登記',
    slogan: 'TOWER 5 – 全新住宅即將登場'
  },
  invest:<>
  <h5>由 SHAPE 傾力打造的 THE AMAZING BRENTWOOD<br/><span>TOWER 5 即將登場</span></h5>
  <p>這是您期待已久的絕佳機遇。作為大溫最為矚目的全新地標，The Amazing Brentwood 現已耀世登場。這裡已為 Neighbourhood One 業主創造了超過6億加元的價值。如今，Tower 5 即將於 Neighbourhood Two 拔地而起，您終於迎來時隔6年多後的首批住宅置業機會。</p>
</>,
  stories: {
    card1: {
      title: <>TOWER 5：我們迄今為止的<br/>最佳地產機遇</>,
      content: '出門即達天車站，The Amazing Brentwood 商圈近在咫尺——從未有任何地段擁有如此羨煞旁人的特權。稍稍遠離喧囂的商業區，背靠壯麗群山和絕美水景，Tower 5 占據該項目最令人夢寐以求的位置，距離充滿活力的 Neighbourhood One 僅數步之遙，且坐落於萬眾期待的 Neighbourhood Two 前排，讓您盡享無遮擋美景。',
      caption: 'TOWER 5：我們迄今為止的最佳地產機遇'
    },
    card2: {
      title: <>TOWER 5：盡享便捷交通和<br/>頂級零售體驗</>,
      content: '歷時10年，斥資超過$12億打造 Neighbourhood One，The Amazing Brentwood 正在改變大溫都市面貌。第一期已建成令人驚艷的3棟住宅大樓，400,000平方英呎零售空間，一個集慶祝活動、藝術和文化於一體的中央廣場，以及一系列精挑細選的零售商，包括卑詩省第一家 The Rec Room，還有 H&M Home、Cineplex VIP、Sephora、Nike、Adidas、Earls、Tap & Barrel、海底撈火鍋、LL Bean、La Taqueria、Small Victory 面包店 和 Bella Gelateria。安家 Tower 5，住戶下樓即可享受這一切繽紛精彩，以及更多即將入駐 Neighbourhood Two 的全新商店和餐廳，成為大溫最火爆新地標的 VIP 貴賓。',
      caption: 'Neighbourhood One'
    },
    card3: {
      title: <>TOWER 5：極富創新的住宅設計<br/>即將揭曉</>,
      content: '因無與倫比的功能性和永不過時的經典設計聞名，SHAPE 的標誌性住宅現已革新升級，旨在將您的居住體驗推至全新高度。超前的先進配置和變革性的空間佈局，將重新定義都市生活；住戶從任何角度皆可欣賞驚艷美景，還可在10,000平方英呎的專屬休閑設施內享受最高端的健身、娛樂和保健體驗——SHAPE 回饋給您的生活方式，沒有任何其他住宅可以比肩。',
      caption: 'SHAPE 全新廚房設計'
    }
  },
  register: {
    title: [
      '把握 TOWER 5',
      ' 絕佳機遇，',
      '立即登記 。'
    ],
    form: {
      firstName: '名字',
      lastName: '姓氏*',
      email: '電子郵箱*',
      phone: '電話號碼*',
      postalCode: '郵編*',
      country: '國家',
      hearAbout: '您是如何得知我們項目的？*',
      isRealtor: '您是地產經紀嗎？*',
      isRealtorEmployer: '雇主/經紀公司 *',
      isWorkingWithRealtor: '您正在與地產經紀合作嗎？',
      isWorkingWithRealtorName: '地產經紀姓名',
      isWorkingWithRealtorEmail: '地產經紀電子郵箱*',
      isWorkingWithRealtorBrokerage: '地產經紀所屬公司',
      isHomeownerAtTAB: '您現在是 The Amazing Brentwood 的零售商/Tower One 租戶/業主嗎 (請選擇一項)？*',
      isTABRetailer: 'Are you a Retailer at The Amazing Brentwood?',
      isTABTenant: 'Are you a Rental Tenant at The Amazing Brentwood?',
      isTABHomeowner: 'Are you a Homeowner at The Amazing Brentwood?',
      questionSelections: {
        hearAbout: {
          id: 'answers[3038][answers]',
          options: [
            {
              value: 'Email Outreach',
              content: '電子郵件推廣'
            },
            {
              value: 'Facebook',
              content: 'Facebook'
            },
            {
              value: 'Friends and Family',
              content: '家人及朋友'
            },
            {
              value: 'Instagram',
              content: 'Instagram'
            },
            {
              value: 'MLS',
              content: 'MLS網站'
            },
            {
              value: 'Online Search',
              content: '線上搜索'
            },
            {
              value: 'Print Publication',
              content: '印刷出版物'
            },
            {
              value: 'Realtor',
              content: '地產經紀'
            },
            {
              value: 'Signage/Walk- or Drive-by',
              content: '廣告牌/步行或駕車經過'
            },
            {
              value: 'WeChat',
              content: '微信'
            },
            {
              value: 'Other',
              content: '其他'
            },
          ]

        },
        isRealtor: {
          id: 'agent',
          options: [
            {
              value: 'false',
              content: '不是'
            },
            {
              values: 'true',
              content: '是'
            }
          ]
        },
        isWorkingWithRealtor: {
          id: 'answers[8454][answers]',
          options: [
            {
              value: 'No',
              content: '不是'
            },
            {
              values: 'Yes',
              content: '是'
            }
          ]
        },
        isOrWorkingWithRealtor: {
          id: 'isOrWorkingWithRealtor',
          options: [
            {
              value: 'Yes, I am realtor',
              content: 'Yes, I am realtor'
            },
            {
              values: 'No, I am not a realtor',
              content: 'No, I am not a realtor'
            },
            {
              value: 'Yes, I am working with a realtor',
              content: 'Yes, I am working with a realtor'
            },
            {
              values: 'No, I am not working with a realtor',
              content: 'No, I am not working with a realtor'
            }
          ]
        },
        isHomeownerAtTAB: {
          id: 'isHomeownerAtTAB',
          options: [
            {
              value: 'No, none of the above',
              content: '以上都不是'
            },
            {
              values: 'Yes, I am retailer',
              content: '是的，我是零售商'
            },
            {
              value: 'Yes, I am a Tower One market rental tenant',
              content: '是的，我是 Tower One 租戶'
            },
            {
              values: 'Yes, I am a current homeowner',
              content: '是的，我是業主'
            }
          ]
        },
        isTABRetailer: {
          id: 'answers[8553][answers]',
          options: [
            {
              value: 'No',
              content: '不是'
            },
            {
              values: 'Yes',
              content: '是'
            }
          ]
        },
        isTABTenant: {
          id: 'answers[8557][answers]',
          options: [
            {
              value: 'No',
              content: '不是'
            },
            {
              values: 'Yes',
              content: '是'
            }
          ]
        },
        isTABHomeowner: {
          id: 'answers[9501][answers]',
          options: [
            {
              value: 'No',
              content: '不是'
            },
            {
              values: 'Yes',
              content: '是'
            }
          ]
        },
        reasonForPurchase: {
          id: 'reasonForPurchase',
          options: [
            {
              value: 'Principal Residence',
              content: 'Principal Residence'
            },
            {
              values: 'Investment',
              content: 'Investment'
            },
            {
              values: 'For Family',
              content: 'For Family'
            }
          ]
        }
        ,
        numberOfHomesRequested: {
          id: 'numberOfHomesRequested',
          options: [
            {
              value: '1',
              content: '1'
            },
            {
              values: '2',
              content: '2'
            },
            {
              values: '3+',
              content: '3+'
            }
          ]
        },
        numberOfBuyers: {
          id: 'numberOfBuyers',
          options: [
            {
              value: '1',
              content: '(1) One - only me'
            },
            {
              values: '2',
              content: '(2) Two - myself and one other'
            },
            {
              values: '3',
              content: '(3) Three - myself and two others'
            },
            {
              values: '4',
              content: '(4) Four - myself and three others'
            },
            {
              values: 'unsure',
              content: 'I’m unsure at the moment'
            }
          ]
        }
        ,
        colourScheme: {
          id: 'colourScheme',
          options: [
            {
              value: '1',
              content: 'option 1'
            },
            {
              values: '2',
              content: 'option 2'
            }
          ]
        },
        homeOptionOneBeds: {
          id: 'homeOptionOneBeds',
          options: [
            {
              value: 'Studio',
              content: 'Studio'
            },
            {
              values: '1 BR',
              content: '1 BR'
            },
            {
              values: '1 BR + D',
              content: '1 BR + D'
            },
            {
              values: '2 BR',
              content: '2 BR'
            },
            {
              values: '2 BR + D',
              content: '2 BR + D'
            },
            {
              values: '3 BR',
              content: '3 BR'
            },
            {
              values: '3 BR + D',
              content: '3 BR + D'
            },
            {
              values: '4 BR ',
              content: '4 BR'
            }
          ]
        },
        isPermanentResident: {
          id: 'isPermanentResident',
          options: [
            {
              value: 'IS',
              content: '是'
            },
            {
              values: 'IS NOT',
              content: '不是'
            }
          ]
        },
        isForeignEntity: {
          id: 'isForeignEntity',
          options: [
            {
              value: 'IS',
              content: '是'
            },
            {
              values: 'IS NOT',
              content: '不是'
            }
          ]
        }
      },
      checkKeepMe: '我同意獲取更多關於 Shape Marketing Corp. 的優先 VIP 體驗和最新房產資訊，並接收來自 Shape Marketing Corp. 的相關電子推廣信息。我可以隨時通過電子郵件 info@shape.ca 或郵遞到 3100 - 1090 Pender Street W., Box 315, Vancouver, BC, Canada V6E 0E3 取消註冊。',
      submit: '提交',
      distclaimer: 'This is not an offering for sale as an offer can only be made when accompanied by a disclosure statement E.&O.E. Sales and Marketing by Shape Marketing.',
    },
  },
  footer: {
    title: <>全新展銷中心和樣板房即將登場</>,
    address: '4567 LOUGHEED HWY, BURNABY',
    phone: '604.563.8386',
    email: 'info@theamazingbrentwood.com',
    rental: '租賃住宅',
    shoppingCentre: '購物中心',
    privacyPolicy: '隱私政策',
    at: '@the.amazing.brentwood',
  }
};
